import React from 'react'
import { styled } from '@mui/system'
import { CardHeader, generateUtilityClasses, Grid, Typography } from '@mui/material'
import { AmountField, DateField, TextField } from '../../../../../../../../../ui'

const classes = generateUtilityClasses('Grid', ['root', 'row', 'optionalText'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [`& .${classes.optionalText}`]: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 400,
    Size: '0.8750em',
    fontStyle: 'italic',
    lineHeight: '1.1875em',
    marginLeft: theme.spacing(1),
  },
}))

const LienForm = () => {
  return (
    <>
      <CardHeader title='Lien' />
      <Grid container spacing={2} padding={3}>
        <Grid item xs={6}>
          <AmountField variant='standard' name='PerDiem' label='Per Diem' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <DateField name='PayoffGoodUntil' label='Payoff Good Until' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <TextField name='AccountNumber' label='Account Number' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <TextField name='Note' label='Comments' fullWidth />
        </Grid>
      </Grid>
    </>
  )
}

export default LienForm
